export var getScrollToHeight = function getScrollToHeight(currentScrollHeight, bottomOfActiveAccordionItem) {
  var amountToScrollBy = bottomOfActiveAccordionItem - global.innerHeight;
  return currentScrollHeight + amountToScrollBy;
};